
import { HttpClient } from '@angular/common/http';
import { ChangeDetectorRef, Component } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';

import { environment } from 'environments/environment';

import { ToastrService } from 'core/toastr.service';
import { mustMatch } from 'core/validators';
import { getSafe } from 'helpers';

import { LogoffService } from '../../logoff.service';
import { IEditPasswordParams } from './password-reset.resolver';

@Component({
  selector: 'app-password-reset',
  templateUrl: './password-reset.component.html'
})

export class PasswordResetComponent {
  errorMessages: Array<string>;
  // disables submit button
  isSubmitting = false;
  pwShown = false;
  resetHeaders: IEditPasswordParams;

  form = new UntypedFormGroup({
    password: new UntypedFormControl('', [Validators.required, Validators.minLength(8)]),
    passwordConfirmation: new UntypedFormControl('', [Validators.required, Validators.minLength(8), mustMatch('password')]),
  });

  constructor(
    private cd: ChangeDetectorRef,
    private toastrService: ToastrService,
    private route: ActivatedRoute,
    private logOffService: LogoffService,
    private httpClient: HttpClient) {
    this.route.data.subscribe(data => {
      this.resetHeaders = data['resetData'];
    });
  }
  onResetClick() {
    this.isSubmitting = true;

    const passwordResetUrl = `${environment.apiBase}/api/auth/password`;
    const formValue = this.form.value;

    this.httpClient.put(passwordResetUrl, {
      password: formValue.password,
      password_confirmation: formValue.passwordConfirmation
    }, {
      params: {
        reset_password_token: this.resetHeaders.token,
      }
    }).subscribe(
      (_) => {
        this.toastrService.success('Your password has been changed.');
        this.logOffService.logoff();
        // this.router.navigateByUrl('/');
      },
      (err) => {
        this.errorMessages = getSafe(() => err.error['errors'], ['An error has occured']);
        this.cd.markForCheck();
      }
    );
  }
}
